import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { getFleetAssetServices } from '../../../services/fleetService';
import { apiParamsState } from '../../../storage/app';
import {
  fleetAssetServicesFiltersState,
  fleetAssetServicesHasAnyFilterState,
  fleetAssetServicesReloadListState,
} from '../../../storage/fleetAssetServices';

export function useFleetAssetServices() {
  const apiParams = useRecoilValue(apiParamsState);
  const [filters, setFilters] = useRecoilState(fleetAssetServicesFiltersState);
  const [reload, setReload] = useRecoilState(fleetAssetServicesReloadListState);
  const resetAllFilters = useResetRecoilState(fleetAssetServicesFiltersState);
  const hasActiveFilters = useRecoilValue(fleetAssetServicesHasAnyFilterState);

  const resetFilters = () => {
    setFilters((prev) => ({
      ...prev,
      configurationId: undefined,
      status: undefined,
    }));
  };

  const onReload = () => {
    setReload((prev) => !prev);
  };

  const onChangeFilter = (filterName: keyof typeof filters, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  const loadFleetAssetServices = async (assetId: string) => {
    if (!apiParams)
      return {
        services: undefined,
        error: 'Selecciona un espacio de trabajo.',
        total: undefined,
      };
    const { services, error, total } = await getFleetAssetServices({
      page: filters.page,
      clientId: apiParams.clientId,
      subClientId: apiParams.subClientId,
      assetId: assetId,
      configurationId: filters.configurationId,
      status: filters.status,
    });
    return {
      services,
      error,
      total,
    };
  };

  return {
    hasActiveFilters,
    loadFleetAssetServices,
    onReload,
    reload,
    resetAllFilters,
    resetFilters,
    page: filters.page,
    onChangePage: (page: number) => {
      onChangeFilter('page', page);
    },
    selectedAssetId: filters.assetId,
    onChangeSelectedAssetId: (assetId?: string) => {
      onChangeFilter('assetId', assetId);
    },
    filters: {
      configurationId: filters.configurationId,
      status: filters.status,
    },
    onChangeFilter: (filterName: 'configurationId' | 'status', value: any) => {
      onChangeFilter(filterName, value);
    },
  };
}
